import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ss-tamanho-completo" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-19" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Produto")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Unidade")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Quantidade")
  ])
], -1)
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-19" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "ant-col ant-col-xs-16 ant-col-xl-2" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "ant-col ant-col-xs-5 ant-col-xl-2" }
const _hoisted_13 = { class: "ant-col ant-col-xs-3 ant-col-xl-1 ss-alinhar-centro" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_form_item, {
              label: "Produto",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_produto, {
                  empresas: _ctx.props.empresas,
                  apresentarCodigoInterno: true,
                  codigoSelecionado: _ctx.state.produtoSelecionado,
                  "onUpdate:codigoSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.produtoSelecionado) = $event)),
                  descricaoSelecionado: _ctx.state.descricaoProduto,
                  "onUpdate:descricaoSelecionado": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.descricaoProduto) = $event)),
                  modoDefinicaoProduto: true,
                  semKits: true
                }, null, 8, ["empresas", "codigoSelecionado", "descricaoSelecionado"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_form_item, {
              label: "Unidade",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_selecionar_unidade_produto_movimento, {
                  apenasUnidadePrincipal: false,
                  codigoProdutoDefinicao: _ctx.state.produtoSelecionado,
                  codigoUnidadeSelecionada: _ctx.state.unidadeSelecionada,
                  "onUpdate:codigoUnidadeSelecionada": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.unidadeSelecionada) = $event)),
                  apresentarApenasSigla: true,
                  buscarDadosAtualizados: _ctx.state.carregandoUnidade,
                  descricao: _ctx.state.descricaoUnidade,
                  "onUpdate:descricao": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.descricaoUnidade) = $event)),
                  editavel: _ctx.props.editavel,
                  casasDecimais: _ctx.state.casasDecimais,
                  "onUpdate:casasDecimais": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.casasDecimais) = $event))
                }, null, 8, ["codigoProdutoDefinicao", "codigoUnidadeSelecionada", "buscarDadosAtualizados", "descricao", "editavel", "casasDecimais"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_form_item, {
              label: "Quantidade",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_campo_numerico, {
                  "quantidade-casas-decimais": _ctx.state.casasDecimais,
                  valor: _ctx.state.quantidade,
                  "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.quantidade) = $event))
                }, null, 8, ["quantidade-casas-decimais", "valor"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_form_item, {
              label: " ",
              class: "ss-margin-campos"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-secondary ant-btn-block",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.adicionarItem && _ctx.adicionarItem(...args)))
                }, "Adicionar")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_7,
        (!_ctx.UtilitarioGeral.validaLista(_ctx.computedItens))
          ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
              key: 0,
              mensagem: "Nenhuma item informado ainda"
            }))
          : (_openBlock(), _createBlock(_component_a_form, {
              key: 1,
              name: "ss-form-produto-fornecedores",
              class: "ss-altura-rolagem-padrao ss-desabilitar-rolagem-horizontal"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedItens, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "ant-row ss-grade-personalizada-linha",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("input", {
                        class: "ant-input",
                        type: "text",
                        value: item.descricaoProduto,
                        disabled: ""
                      }, null, 8, _hoisted_9)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("input", {
                        class: "ant-input",
                        type: "text",
                        value: item.descricaoUnidade,
                        disabled: ""
                      }, null, 8, _hoisted_11)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_campo_numerico, {
                        "quantidade-casas-decimais": item.casasDecimais,
                        valor: item.quantidade,
                        disabled: true
                      }, null, 8, ["quantidade-casas-decimais", "valor"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-secondary",
                        onClick: ($event: any) => (_ctx.removerItem(index))
                      }, [
                        _createVNode(_component_icone, { nome: "excluir" })
                      ], 8, _hoisted_14)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ]))
}